import type React from "react";

// import { Link } from "@heroui/link";
// import { Trans, useTranslation } from "react-i18next";

// import { Navbar } from "@/components/navbar";
import { SidebarLayoutInvestAI } from "@/components/Sidebar/SidebarLayout-InvestAI";
import { SidebarLayout } from "@/components/Sidebar/SidebarLayout";
import { SidebarProvider } from "@/components/Sidebar/SidebarContext";
import { logger } from "@/telemetry";

export default function DefaultLayout({
  children,
  brandName,
}: {
  children: React.ReactNode;
  brandName?: string;
}) {
  logger.info("brandName", { brandName: brandName ?? "undefined" });
  if (brandName === "Invest Ai") {
    return (
      <SidebarProvider>
        <div className="relative flex flex-col w-full" style={{ height: "var(--app-height)" }}>
          <main className="w-full flex-grow m-0">
            <SidebarLayoutInvestAI>
              {/* <Navbar /> */}
              {children}
            </SidebarLayoutInvestAI>
          </main>
        </div>
      </SidebarProvider>
    );
  } else
    return (
      <SidebarProvider>
        <div className="relative flex flex-col w-full" style={{ height: "var(--app-height)" }}>
          <main className="w-full flex-grow m-0">
            <SidebarLayout>
              {/* <Navbar /> */}
              {children}
            </SidebarLayout>
          </main>
          {/*<footer className="w-full flex items-center justify-center py-3">
         <Link
          isExternal
          className="flex items-center gap-1 text-current"
          href="https://webuild-ai.com"
          title={t("heroui-com-homepage")}
        >
           <span className="text-default-600">
            <Trans ns="base">powered-by</Trans>
          </span>
          <p className="text-primary">WeBuild AI™</p>
        </Link>
      </footer> */}
        </div>
      </SidebarProvider>
    );
}
